import { Route, Routes } from "react-router-dom";
import Container from "../../base/Container";

import ScheduleMeeting from "./ScheduleMeeting";
import Dashboard from "./Dashboard";


const ScheduleMeetContainer = () => {
  return (
    <Container contentStyle={{ padding: 0 }}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/commission" element={<Dashboard/>} />
        <Route path="/schedule-meeting" element={<ScheduleMeeting />} />
    
      </Routes>
    </Container>
  );
};

export default ScheduleMeetContainer;
